import {recordPageLoad} from "~/applicationAnalytics/core/capture";

/** loadEventEnd is populated only after all load event handlers have returned. */
export function trackInitialPageLoad(): () => void {
    let timer: ReturnType<typeof setTimeout> | undefined;
    const onLoad = () => {
        const path = window.location.pathname;
        timer = setTimeout(() => {
            try {
                const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
                if (nav === undefined || nav.loadEventEnd <= 0) {
                    return;
                }
                recordPageLoad({
                    page_load_time_ms: Math.round(nav.loadEventEnd - nav.startTime),
                    load_type: "initial_load",
                    path,
                    ttfb_ms: Math.round(nav.responseStart - nav.requestStart),
                    dom_interactive_ms: Math.round(nav.domInteractive - nav.startTime),
                });
            } catch {
                // Navigation timing is unavailable in some browsers.
            }
        }, 0);
    };
    if (document.readyState === "complete") {
        onLoad();
    } else {
        window.addEventListener("load", onLoad, {once: true});
    }
    return () => {
        window.removeEventListener("load", onLoad);
        clearTimeout(timer);
    };
}
